import { Button } from "antd";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { ListPage } from "../../components/ListPage";
import { DocumentStatusTag } from "../../components/DocumentStatusTag";
import { SiteLabel } from "../../components/SiteLabel";
import { DT_FORMATS } from "../../helpers/constants";
import { hasAnyGrant } from "../../helpers/permissions";
import { useUser } from "../../context/UserContext";
import type { BoatNote } from "../../api-models";

export default function BoatNotesListPage() {
  const navigate = useNavigate();
  const { user } = useUser();
  const canWrite = hasAnyGrant(user, "BoatNotes.Write");

  return (
    <ListPage<BoatNote>
      title="Boat Notes"
      endpoint="/boat-notes"
      searchPlaceholder="Search doc no, boat or contact..."
      linkTo={(r) => `/boat-notes/${r.id}`}
      actions={
        canWrite && (
          <Button type="primary" onClick={() => navigate("/boat-notes/new")} data-tour="boat-notes-new">
            New boat note
          </Button>
        )
      }
      columns={[
        { title: "Doc No", dataIndex: "docNo", sorter: true },
        { title: "Boat", dataIndex: "boatName" },
        { title: "Site", render: (_, r) => <SiteLabel site={r.site} /> },
        {
          title: "Submitted",
          dataIndex: "submissionDate",
          sorter: true,
          render: (v) => (v ? dayjs(v).format(DT_FORMATS.date) : "-"),
        },
        { title: "Status", render: (_, r) => <DocumentStatusTag status={r.status} /> },
      ]}
      renderCard={(r) => (
        <div>
          <strong>{r.docNo}</strong> <DocumentStatusTag status={r.status} />
          <div>{r.boatName}</div>
          <div>
            <SiteLabel site={r.site} />
          </div>
        </div>
      )}
    />
  );
}
